module.exports = "<div class=\"outer-container\">\n  <ng-container *ngIf=\"pageContent\">\n    <div [innerHTML]=\"pageContent\" class=\"content\"></div>\n  </ng-container>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/pages/pages.component.html
// module id = ../../../../../src/app/pages/pages.component.html
// module chunks = main